<template>
	<tile-card :default-actions="false">
		<v-card-title>
			<v-icon class="connectionIcon" :color="iconColor">{{ icon }}</v-icon>
			<span>Controller</span>
		</v-card-title>
		<v-card-subtitle>
			<b>Status:</b>
			{{ subtitle }}{{ ellipsis }}
			<br />
			<b>Host:</b>
			<br />
			<span class="nowrap">{{ controllerIP }}</span>
		</v-card-subtitle>
	</tile-card>
</template>

<style lang="scss" scoped>
.connectionIcon {
	margin-right: 0.7ex;
}

.nowrap {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>

<script>
import _ from "lodash";

import TileCard from "../../shared/TileCard";
import { mapGetters } from "vuex";

export default {
	components: { TileCard },

	computed: {
		...mapGetters({
			state: "controller/state",
			states: "controller/states",
			status: "controller/status",
		}),

		isConnected() {
			return this.state === this.states.CONNECTED;
		},

		controllerIP() {
			return this.$store.state.controller.ip;
		},

		subtitle() {
			return _.startCase(_.lowerCase(this.status));
		},

		ellipsis() {
			return this.state === this.states.DISCOVERED ? "..." : ""
		},

		icon() {
			switch (this.state) {
				case this.states.UNKNOWN:
					return "far fa-circle";
				case this.states.DISCOVERED:
					return "far fa-dot-circle";
				case this.states.CONNECTED:
					return "fa-dot-circle";

				case this.states.NOT_AVAILABLE:
				case this.states.NOT_FOUND:
				default:
					return "fa-circle-notch";
			}
		},

		iconColor() {
			switch (this.state) {
				case this.states.UNKNOWN:
					return "grey";
				case this.states.DISCOVERED:
					return "orange";
				case this.states.CONNECTED:
					return "green";

				case this.states.NOT_AVAILABLE:
				case this.states.NOT_FOUND:
				default:
					return "red";
			}
		},
	},
};
</script>
